import apiClient from './client'

export interface SellerAllIdsResponse {
  releaseIds: number[]
  totalListings: number
  pagesCount: number
  fetchedListings: number
  truncated: boolean
}

export interface SellerProgress {
  pass: number
  totalPasses: number
  page: number
  totalPages: number
  idsFound: number
  done: boolean
  paused: boolean
  error?: string
}

export async function getSellerAllIds(username: string): Promise<SellerAllIdsResponse> {
  const { data } = await apiClient.get(`/seller/${encodeURIComponent(username)}/all-ids`)
  if (!data.success) throw new Error(data.message)
  return data.data
}

export async function getSellerProgress(username: string): Promise<SellerProgress | null> {
  const { data } = await apiClient.get(`/seller/${encodeURIComponent(username)}/progress`)
  return data.data
}
